import { SessionStorage, Storage } from '@/utils/storage'
import CacheKey from '@/utils/cache/key'
import { ITheme } from '@/store/theme/interface'
import { themeConfig } from '@/store/theme/config'

// 缓存
class Cache {
	getToken = (): string => {
		return Storage.getItem(CacheKey.TokenKey) || ''
	}

	setToken = (value: string) => {
		Storage.setItem(CacheKey.TokenKey, value)
	}

	getSidebarOpened = (): boolean => {
		return Storage.getItem(CacheKey.SidebarOpenedKey) || false
	}

	setSidebarOpened = (value: boolean) => {
		Storage.setItem(CacheKey.SidebarOpenedKey, value)
	}

	getLanguage = (): string => {
		return Storage.getItem(CacheKey.LangKey) || 'zh-CN'
	}

	setLanguage = (value: string) => {
		Storage.setItem(CacheKey.LangKey, value)
	}

	getComponentSize = (): string => {
		return Storage.getItem(CacheKey.ComponentSizeKey) || 'default'
	}

	setComponentSize = (value: string) => {
		Storage.setItem(CacheKey.ComponentSizeKey, value)
	}

	getTheme = (): ITheme => {
		return (Storage.getItem(CacheKey.ThemeKey) as ITheme) || themeConfig
	}

	setTheme = (value: ITheme) => {
		Storage.setItem(CacheKey.ThemeKey, value)
	}

	removeTheme = () => {
		Storage.removeItem(CacheKey.ThemeKey)
	}

	getBodyHeight = () => {
		let defaultHeight = document.body.clientHeight - 265
		let sizeKey = Storage.getItem(CacheKey.ComponentSizeKey) || 'default'
		if(sizeKey == 'default'){
			return defaultHeight
		}else if(sizeKey == 'large'){
			return defaultHeight - 10
		}else if(sizeKey == 'small'){
			return defaultHeight + 7
		}
	}
}

export default new Cache()
